module.exports = __webpack_public_path__ + "img/4.d3a33ad3.jpg";